import { render, staticRenderFns } from "./chill.vue?vue&type=template&id=98b341b0&lang=pug&"
import script from "./chill.vue?vue&type=script&lang=js&"
export * from "./chill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports